import { Component, HostBinding, ViewEncapsulation, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base.component';

@Component({
  selector: 'app-message-block',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './message-block.component.html',
  styleUrls: [
    './message-block.component.scss',
    './rich-text-content-styles.scss'
  ]
})
export class MessageBlockComponent extends BaseComponent implements OnInit {

  @HostBinding('class.message-opened') @Input() opened = false;

  @Input() message: any;
  @Input() showDeleteBtnYN = false;
  @Input() showUnreadStyleYN = false;
  @Input() showRecipientListYN = false;
  @Output() messageOpened = new EventEmitter<any>();
  @Output() messageArchive = new EventEmitter<any>();


  ngOnInit(): void {
    // console.log(this.message);
  }

  recipientDisplayText(message) {
    if (message.SentCount === 1) {
      if (message.MessageToList &&  message.MessageToList.length > 0) {
        return `${message.MessageToList[0].FirstName} ${message.MessageToList[0].LastName}`;
      }
    } else {
      return `${message.SentCount} people`;
    }
  }


  panelOpened(): void {
    this.opened = true;
    this.messageOpened.emit(this.message);
  }


  panelClosed(): void {
    this.opened = false;
  }


  get readMessages() {
    if (this.message && this.message.MessageToList) {
      return this.message.MessageToList.filter(item => item.MessageReadYN);
    }
    return null;
  }


  get unreadMessages() {
    if (this.message && this.message.MessageToList) {
      return this.message.MessageToList.filter(item => !item.MessageReadYN);
    }
    return null;
  }


  archive(event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.messageArchive.emit(this.message);
  }

}
